import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import Navbar from "../components/Navbar";
import { Search, Ticket } from "lucide-react";

export default function StatusLookup() {
  const navigate = useNavigate();
  const [reference, setReference] = useState("");
  const [loading, setLoading] = useState(false);

  const lookup = async (e) => {
    e.preventDefault();
    const ref = reference.trim().toUpperCase();
    if (!ref) { toast.error("Please enter your registration reference."); return; }
    setLoading(true);
    try {
      await api.get(`/orders/${ref}`);
      navigate(`/confirmation/${ref}`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration not found.");
    } finally { setLoading(false); }
  };

  return (
    <div>
      <Navbar />
      <div className="max-w-lg mx-auto px-4 py-16 sm:py-24">
        <div className="rounded-2xl bg-white border border-[#E2EBF0] shadow-xl p-8">
          <div className="w-12 h-12 rounded-xl bg-[#F2F8F5] text-[#008057] flex items-center justify-center"><Ticket size={24} /></div>
          <h1 className="font-display text-3xl font-extrabold text-[#03281B] mt-4">Check Your Registration</h1>
          <p className="text-slate-600 mt-2">Enter your registration reference (e.g. <span className="font-mono font-semibold">SCAR27-ABC123</span>) to view your current registration and payment status.</p>
          <form onSubmit={lookup} className="mt-6">
            <div className="relative">
              <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                data-testid="status-lookup-input"
                value={reference}
                onChange={(e) => setReference(e.target.value)}
                placeholder="SCAR27-XXXXXX"
                className="w-full rounded-xl border-2 border-[#E2EBF0] pl-10 pr-3 py-3 font-mono uppercase focus:border-[#008057] outline-none"
              />
            </div>
            <button data-testid="status-lookup-submit" disabled={loading} className="mt-4 w-full rounded-full bg-[#008057] hover:bg-[#054D34] text-white py-3 font-bold disabled:opacity-60 transition-colors">
              {loading ? "Looking up..." : "View My Registration"}
            </button>
          </form>
          <p className="text-xs text-slate-400 mt-4 text-center">Your reference was sent to your email when you registered.</p>
        </div>
      </div>
    </div>
  );
}
